<template>
  <div
    v-bind:class="{ 'quick-search-has-result': hasResult() }"
    class="quick-search quick-search-dropdown quick-search-result-compact"
    id="kt_quick_search_dropdown"
  >
    <form method="get" class="quick-search-form">
      <div
        class="input-group spinner-input spinner-sm spinner-brand spinner-right"
        v-bind:class="{ spinner: loading }"
      >
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="flaticon2-search-1"></i>
          </span>
        </div>
        <input
          v-on:keyup="onSearch"
          type="text"
          class="form-control quick-search-input"
          placeholder="Поиск товара..."
          v-model="filter.search"
        />
        <div class="input-group-append">
          <span class="input-group-text">
            <i
              class="quick-search-close"
              v-on:click="reset"
              v-bind:style="{ display: hasResult() ? 'flex' : '' }"
            ></i>
          </span>
        </div>
      </div>
    </form>

    <KTSearchResult v-bind:data="data"></KTSearchResult>
  </div>
</template>

<script>
import KTSearchResult from "@/view/layout/extras/dropdown/SearchResult.vue";

import { mapGetters } from "vuex";
import {GET_PRODUCTS_SEARCH} from "../../../../core/services/store/search.module";
import {SET_ALERT} from "../../../../core/services/store/alert.module";

export default {
  name: "KTSearchDefault",
  components: { KTSearchResult },
  computed: {
    ...mapGetters({
      result: 'gettersProductsSearch',
      loading: 'getProductLoadSearch',
    }),
  },

  data() {
    return {
      data: [],

      filter: {
        search: '',
      },
    };
  },
  methods: {
    onSearch(event) {
      if (event.target.value.length > 2) {
        this.$store.dispatch(GET_PRODUCTS_SEARCH, {'filter': this.filter})
                .then(() => {
                  this.data = this.result;
                })
                .catch(() => {
                  this.showAlert('Ошибка поиска, попробуйте позже', 'danger', 'toast');
                })
                .finally(() => {

                });
      }
    },


    showAlert(text, variant, type) {
      this.$store.commit(SET_ALERT, {text, variant, type});
    },

    /**
     * Check if the data has result
     * @returns {boolean}
     */
    hasResult() {
      return this.data.length || false;
    },
    /**
     * Reset search data
     */
    reset() {
      this.data = [];
    }
  }
};
</script>
